// Libs
import React, { } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Collapse, Table, Tooltip } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { GetAquivoExportaHistoricoMedicaoCMG } from '@app/api/contrato';
import { CreatBoletimMedicaoPorContrato, gelAllResumoMedicoes } from '@app/api/boletimMedicao';

//Files

//Utils
import { isEmptyOrSpaces } from '@app/helpers/stringHelper';

const { Panel } = Collapse;

interface PanelResumoMedicoesProps {
    contratoId: string;
    planilhaSelecionada: CreatBoletimMedicaoPorContrato;
}

export const PanelResumoMedicoes = ({
    contratoId,
    planilhaSelecionada
}: PanelResumoMedicoesProps) => {

    const collResumoMedicoes = [
        {
            title: 'Nº',
            dataIndex: 'numero',
            width: '1%',
        },
        {
            title: 'Origem',
            dataIndex: 'tipo',
            width: '5%',
        },
        {
            title: 'Tipo',
            dataIndex: 'tiposMedicoes',
            width: '5%',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: '10%',
        },
        {
            title: 'Período',
            dataIndex: 'periodo',
            width: '15%',
        },
        {
            title: 'Aditivo vigente',
            dataIndex: 'nmAditivoVigente',
            width: '4%',
        },
        {
            title: 'Valor ',
            dataIndex: 'slFinalMedicao',
            width: '10%',
        },
        {
            title: 'SLA',
            dataIndex: 'sla',
            width: '10%',
            render: (index: any, item: any) => {
                return (
                    <>
                        {item.possuiSla ? (
                            <>
                                <span>
                                    {isEmptyOrSpaces(item.bonusSla) ? (
                                        <> N/A </>
                                    ) : (
                                        <div className={item.bonusSla === 'R$0,00' ? 'spanPenaltSlaBlack' : 'spanBonusSla'}>
                                            {' '}
                                            {`Bonus: ${item.bonusSla}`}{' '}
                                        </div>
                                    )}
                                    {isEmptyOrSpaces(item.penaltSla) ? (
                                        <> N/A</>
                                    ) : (
                                        <div className={item.penaltSla === 'R$0,00' ? 'spanPenaltSlaBlack' : 'spanPenaltSlaRed'}>
                                            {' '}
                                            {`Pênalt: ${item.penaltSla}`}
                                        </div>
                                    )}
                                </span>
                            </>
                        ) : (
                            <> N/A</>
                        )}
                    </>
                );
            },
        },
        {
            title: 'Status SLA',
            dataIndex: 'statusSla',
            width: '10%',
            render: (index: any, item: any) => {
                return <>{item.possuiSla ? <>{item.statusSla}</> : <> N/A </>}</>;
            },
        },
        {
            title: 'Valor Real (VALOR - SLA)',
            dataIndex: 'valorReal',
            width: '10%',
        },
        {
            title: 'Status Rateio',
            dataIndex: 'statusRateio',
        },

        {
            title: 'Ações',
            width: '5%',
            render: (index: any, item: any) => {
                return (
                    <Tooltip title="Ir para BM">
                        <ui.Button
                            type="link"
                            icon="arrows-circled_up_right_2"
                            name="irparaBm"
                            onClick={() => {
                                let urlBase = window.location.origin;
                                window.open(urlBase + `/boletimDeMedicoes/detail/${item.id}/${contratoId}`);
                            }}
                            href="#"
                        />
                    </Tooltip>
                );
            },
        },
    ];

    const [GelAllResumoMedicoesConsult] = ui.usePromise(
        () =>
            contratoId
                ? gelAllResumoMedicoes(contratoId, planilhaSelecionada.planilhaDeQuantidadeId)
                    .then(resp => {
                        return resp;
                    })
                : Promise.resolve(undefined),
        [planilhaSelecionada],
        [],
    );

    const baixarArquivo = () => {
        if (contratoId) {
            GetAquivoExportaHistoricoMedicaoCMG(contratoId, planilhaSelecionada.planilhaDeQuantidadeId);
        }
    };

    return (
        <Collapse bordered={false} expandIcon={() => <ui.Icon type="arrows-right_4" />}>
            <Panel key="resumoMedicoes" header={'Resumo das Medições'} style={{ border: 0 }}>
                <ui.Widget
                    actions={[
                        <Tooltip title="Exporta Historico da Medição">
                            <ui.Button
                                type="primary"
                                onClick={() => {
                                    baixarArquivo();
                                }}
                                icon="ui-download"
                                name="btnBaixarArquivo">
                                Histórico Medições
                            </ui.Button>
                        </Tooltip>,
                    ]}>
                    <PerfectScrollbar>
                        <Table
                            rowKey="id"
                            columns={collResumoMedicoes}
                            dataSource={GelAllResumoMedicoesConsult}
                            pagination={false}
                        />
                    </PerfectScrollbar>
                </ui.Widget>
            </Panel>
        </Collapse>
    )
}
